import { EProjectStatus } from '@/models/dtos/enums/eProjectStatus'
import { SelectDto } from '@/models/dtos/selectDto'
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { ProjectMixin } from './projectMixin'

@Component
export class SelectMixin extends mixins(ProjectMixin) {
  mapObjectToSelect<T>(objects: T[],
    fields: {
      value: keyof T;
      text: keyof T | ((p: T) => string);
      disabled?: (p: T) => boolean;
    }): SelectDto[] {
    const result: SelectDto[] = objects.map(obj => {
      const val = obj[fields.value]
      let text

      (typeof fields.text === 'function')
        ? text = fields.text(obj)
        : text = obj[fields.text]

      const res: SelectDto = {
        value: typeof val === 'string' || typeof val === 'number' ? val.toString() : null,
        text: typeof text === 'string' || typeof text === 'number' ? text.toString() : ''
      }

      if (fields.disabled) {
        res.disabled = fields.disabled(obj)
      }

      return res
    })

    return result
  }

  mapEnumToSelect<T>(en: T, nameResolver: Function, exclude: (keyof T)[]): SelectDto[] {
    const res: SelectDto[] = []

    Object.keys(en).map(key => {
      if (isNaN(Number(key))) {
        const val = (en as any)[key]
        if (!exclude.some(exKey => key === exKey)) {
          const status = { value: val.toString(), text: nameResolver(val) }
          res.push(status)
        }
      }
    })

    return res
  }
}
